module.exports = __webpack_public_path__ + "img/温度显示.884db5d4.gif";